import './bootstrap';
import '../css/app.css';    // Imported css file [TailwindCSS]
import 'phosphor-icons';
import { createApp } from 'vue';
import CopyToClipboard from "@/components/CopyToClipboard.vue";
import { initializeAttestations } from './attestations.js';

// Make Vue available globally
window.Vue = { createApp };

// Register global components
window.VueComponents = {
    CopyToClipboard
};

// Make attestations functions available globally
window.initializeAttestations = initializeAttestations;


// Imported flowbite
import {
    Accordion,
    Carousel,
    Collapse,
    Dial,
    Dismiss,
    Drawer,
    Dropdown,
    Modal,
    Popover,
    Tabs,
    Tooltip,
    initAccordions,
    initCarousels,
    initCollapses,
    initDials,
    initDismisses,
    initDrawers,
    initDropdowns,
    initModals,
    initPopovers,
    initTabs,
    initTooltips
} from 'flowbite';


const accordionSideBarItems = [
    {
        id: 'accordion-sidebar-heading-1',
        triggerEl: document.querySelector('#accordion-sidebar-heading-1'),
        targetEl: document.querySelector('#accordion-sidebar-body-1'),
        active: false
    }
];

// options with default values
const optionsSideBar = {
    alwaysOpen: false,
    activeClasses: 'bg-transparent dark:bg-sky-350',
    inactiveClasses: 'text-gray-500 dark:text-gray-400',
    onOpen: (item) => {
        const accordionSidebar = document.getElementById('accordion-sidebar');
        accordionSidebar.classList.add('bg-sky-100');
        accordionSidebar.classList.add('p-2');
        accordionSidebar.classList.add('rounded-xl');
        const nameSidebar = document.getElementById('accordion-sidebar-heading-1');
        nameSidebar.classList.add('bg-sky-350');
    },
    onClose: (item) => {
        const accordionSidebar = document.getElementById('accordion-sidebar');
        accordionSidebar.classList.remove('bg-sky-100');
        accordionSidebar.classList.remove('p-2');
        accordionSidebar.classList.remove('rounded-xl');
        const nameSidebar = document.getElementById('accordion-sidebar-heading-1');
        nameSidebar.classList.remove('bg-sky-350');
    },
};

const accordion = new Accordion(accordionSideBarItems, optionsSideBar);

// Global function for updating content progress in real-time
window.updateContentProgressGlobal = function(contentId, progress, status, trackingData) {
    console.log(`🔄 Global update: content ${contentId} progress: ${progress}%, status: ${status}`);

    // Update progress bars
    const progressBars = document.querySelectorAll(`[data-content-id="${contentId}"] .progress-bar, [data-content="${contentId}"] .progress-bar`);
    progressBars.forEach(bar => {
        const progressFill = bar.querySelector('.progress-fill, .bg-blue-500, .bg-green-500');
        if (progressFill) {
            progressFill.style.width = `${progress}%`;
        }
    });

    // Update progress percentages
    const progressTexts = document.querySelectorAll(`[data-content-id="${contentId}"] .progress-text, [data-content="${contentId}"] .progress-percentage`);
    progressTexts.forEach(text => {
        text.textContent = `${Math.round(progress)}%`;
    });

    // Update status badges
    const statusElements = document.querySelectorAll(`[data-content-id="${contentId}"] .status-badge, [data-content="${contentId}"] .content-status`);
    statusElements.forEach(statusEl => {
        // Remove old status classes
        statusEl.classList.remove('bg-yellow-100', 'text-yellow-800', 'bg-blue-100', 'text-blue-800', 'bg-green-100', 'text-green-800');

        // Add new status classes and text
        if (status === 'finished') {
            statusEl.classList.add('bg-green-100', 'text-green-800');
            statusEl.textContent = 'Terminé';
        } else if (status === 'started') {
            statusEl.classList.add('bg-blue-100', 'text-blue-800');
            statusEl.textContent = 'En cours';
        } else {
            statusEl.classList.add('bg-yellow-100', 'text-yellow-800');
            statusEl.textContent = 'Disponible';
        }
    });

    // Update button text based on status
    const actionButtons = document.querySelectorAll(`[data-content-id="${contentId}"] .action-button, [onclick*="${contentId}"]`);
    actionButtons.forEach(button => {
        if (status === 'finished') {
            button.textContent = 'Relire';
        } else if (status === 'started') {
            button.textContent = 'Continuer';
        } else {
            button.textContent = "C'est parti !";
        }
    });

    // Update score if available
    if (trackingData && trackingData.score !== undefined) {
        const scoreElements = document.querySelectorAll(`[data-content-id="${contentId}"] .content-score`);
        scoreElements.forEach(scoreEl => {
            scoreEl.textContent = `${trackingData.score}/100`;
        });
    }

    console.log(`✅ Global interface updated for content ${contentId}`);
};
